module.exports = __webpack_public_path__ + "static/img/product5-2.1f0a2c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product5-2.jpg
// module id = oB1Z
// module chunks = 0